import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { NoResultCSSStyleImpl } from './noresultcss';
import { NoResultViewImpl } from './noresultview';

export interface NoResultComponentProps extends UIComponentProps
{
    
}

export interface NoResultComponentHandler extends UIComponentHandler
{

}

export class NoResultComponent extends UIComponentImpl<NoResultComponentProps, UIComponentState, UIDataModel> 
implements NoResultComponentHandler
{

    constructor(props: NoResultComponentProps)
    {
        super(props);

    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new NoResultViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new NoResultCSSStyleImpl(applicationContext);
    }
    
    // protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    // {
    //      return new NameTunesAPIModelImpl(applicationContext, apiModelHandler);
    // }
    
    // onSearchClicked(searchKey:string):void
    // {
    //     this.props.onSearchClicked(searchKey);
    // }

    // onRequestNow():void
    // {
    //     this.props.onRequestNow();
    // }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/noresult/noresultcomponent.tsx